import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	goals: {
		id: 'servicedesk-sla-settings.common.goals.goal-title.goals',
		defaultMessage: 'Goals',
		description: 'header for goals section',
	},
	metricInformationTip: {
		id: 'servicedesk-sla-settings.common.goals.goal-title.metric-information-tip',
		defaultMessage:
			'Issues will be checked against this list, top to bottom, and assigned a time goal based on the first matching JQL statement.',
		description: 'Open tip for issues based on metric conditions',
	},
});
